const initialState = {
    tasks:[],
    sprintData: {},
    sprintmemebers: {},
    isUpdate:false,
  }
  
  const taskListReducer = (state = initialState, action) => {
    switch (action.type) {
      case "GET_TASK_DATA":
        return {
          ...initialState,
            tasks:[...action.data.task],
            // sprintData: {...action.data.sprintDetails},
            // sprintmemebers: {...action.data.sprintmemebers},
            totalPages: Math.ceil(action.sprintsCount / action.params),
            isUpdate:false
        }

        case "GET_MY_TASK_DATA":
        return {
          ...initialState,

            tasks:[...action.data],
            // sprintData: {...action.data.sprintDetails},
            // sprintmemebers: {...action.data.sprintmemebers},
            totalPages: Math.ceil(action.sprintsCount / action.params),
            isUpdate:false
        }

        case "GET_OTHERS_TASK_DATA":
        return {
            tasks:[...action.data],
            // sprintData: {...action.data.sprintDetails},
            // sprintmemebers: {...action.data.sprintmemebers},
            totalPages: Math.ceil(action.sprintsCount / action.params),
            isUpdate:false
        }

        case "GET_OPEN_TASK_DATA":
        return {
            tasks:[...action.data],
            // sprintData: {...action.data.sprintDetails},
            // sprintmemebers: {...action.data.sprintmemebers},
            totalPages: Math.ceil(action.sprintsCount / action.params)
        }
        case "GET_SPRINT_MEMBERS_DATA":
          return {
              sprintData: {...action.data.sprintDetails},
              sprintmemebers: {...action.data.sprintmemebers}
          }

        case "DELETE_TASK_DATA":
          return{
            tasks: [...state.tasks.filter(tasks=>tasks._id != action.data)],
            sprintData: {...action.data.sprintDetails},
            sprintmemebers: {...action.data.sprintmemebers},
            isUpdate:true,
          }
      
    
      case "ADD_TASK_DATA":
        return {
            tasks: [],
            sprintData: {...state.sprintData},
            sprintmemebers: {...state.sprintmemebers},
            isUpdate:true
        }

      case "UPDATE_TASK_DATA":
        let index = state.tasks.findIndex(ind => ind._id === action.data[0]._id)
        return {
            tasks:[...state.tasks.slice(0, index), action.data[0], ...state.tasks.slice(index+1)],
            sprintData: {...state.sprintData},
            sprintmemebers: {...state.sprintmemebers},
            isUpdate:true
        }

      default:
        return initialState
    }
  }
  
  export default taskListReducer